module.exports = __webpack_public_path__ + "static/media/applogo.dce5d07b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/applogo.svg
// module id = 648
// module chunks = 11